import { render } from "./NotaryPricing.vue?vue&type=template&id=360a32e1"
import script from "./NotaryPricing.vue?vue&type=script&lang=js"
export * from "./NotaryPricing.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ContentCreator/Functional/NotaryPricing.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "360a32e1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('360a32e1', __exports__)) {
    api.reload('360a32e1', __exports__)
  }
  
  module.hot.accept("./NotaryPricing.vue?vue&type=template&id=360a32e1", () => {
    api.rerender('360a32e1', render)
  })

}


export default __exports__